import * as Observe from 'src/util/observe';
import * as Network from 'src/clients/Network';

export type AsyncValueDataType = Network.gql.build.topRankingQuery.topRankingQuery['response']['invsysTopRanking'];
export type PersonalRankingValueDataType =
  Network.gql.build.personalRankingQuery.personalRankingQuery['response']['invsysPersonalRanking'];

export const Value = Observe.Value<null | AsyncValueDataType>(null);
export const PersonalRankingValue = Observe.Value<null | PersonalRankingValueDataType>(null);
